import api, { extractClientErrorMessage } from '../../../axios/axios-api'

export default {
  /**
   * Solicita un JWT temporal al back (POST /api/turnos/public/session).
   * El servidor prioriza ficha con HabilitadoPortalPaciente; si no hay, intenta la
   * misma búsqueda por documento sin ese filtro (p. ej. ficha alta desde autogestión).
   * Si no hay ficha y el centro permite autogestión sin ficha, devuelve sesión sin ficha_id.
   */
  async requestTemporalSession({ commit, rootState }) {
    const tdId = Number(rootState?.guestSession?.tdId)
    const nroDoc = String(rootState?.guestSession?.nroDoc ?? '').trim()
    const fechaNacimiento = String(rootState?.guestSession?.fechaNacimiento ?? '').trim()
    const sexo = String(rootState?.guestSession?.sexo ?? '').trim().toUpperCase()
    if (!Number.isFinite(tdId) || tdId <= 0 || !nroDoc) {
      return { ok: false, mensaje: 'Indique tipo y número de documento.' }
    }
    if (!fechaNacimiento || (sexo !== 'F' && sexo !== 'M')) {
      return { ok: false, mensaje: 'Indique fecha de nacimiento y género.' }
    }
    try {
      const { data } = await api.post(
        'turnos/public/session',
        { tdId, nroDoc, fechaNacimiento, sexo },
        { skipGlobalErrorAlert: true },
      )
      const accessToken = String(data?.accessToken ?? '').trim()
      if (!accessToken) {
        return { ok: false, mensaje: 'No se recibió token temporal del servidor.' }
      }
      const minutos = Number(data?.expiresInMinutes)
      const expiresInMs =
        Number.isFinite(minutos) && minutos > 0 ? minutos * 60 * 1000 : 15 * 60 * 1000
      const expiresAt = Date.now() + expiresInMs
      const fichaId = Number(data?.fichaId)
      const sinFicha = data?.sinFichaAutogestionSession === true
      commit('patchGuestSession', {
        accessToken,
        sessionId: String(data?.sessionId ?? '').trim(),
        expiresAt,
        fichaId: Number.isFinite(fichaId) && fichaId > 0 ? fichaId : null,
        sinFichaAutogestion: sinFicha,
      })
      return { ok: true, accessToken, expiresAt }
    } catch (e) {
      const msg = extractClientErrorMessage(e?.response?.data)
      const code = e?.response?.data?.errorCode ?? e?.response?.data?.ErrorCode
      const mensajePacienteInexistente = String(
        rootState?.portalHome?.portalPrivateParams?.mjePacienteInexistente ?? '',
      ).trim()
      const notFoundUsuario =
        e?.response?.status === 404 || code === 'paciente_sin_ficha_o_no_habilitado'
      const datosNoCoinciden = code === 'datos_paciente_no_coinciden'
      return {
        ok: false,
        mensaje: datosNoCoinciden
          ? 'Los datos ingresados no coinciden con la ficha del paciente.'
          : notFoundUsuario
          ? mensajePacienteInexistente
            || 'No encontramos un paciente registrado con el número de documento ingresado.'
          : msg || 'No se pudo iniciar la sesión para sacar turno. Intente nuevamente.',
      }
    }
  },
}
